export class PathBase {
	static readonly pathKey: string;
	protected static _pathName?: string | undefined;

	constructor(protected parentPath = "") {}

	static set pathName(pathName: string) {
		this._pathName = pathName;
	}

	static get pathName() {
		return this._pathName ?? this.pathKey;
	}

	get path(): string {
		if (!this.parentPath && !(this.constructor as typeof PathBase).pathName) return "";
		return `${this.parentPath}/${(this.constructor as typeof PathBase).pathName}`;
	}
}
